import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from '../../../../../axios-instance';
import Upload from '../../../../Upload/Upload';
import { getCustomURLs } from '../../../../../helpers/getCustomURLs';

import { getHeaders } from '../../../../../helpers/getHeaders';
import NewLoader from '../../../../../components/NewLoader/NewLoader';
import './EventGuestlist.sass';

export const UploadFileModal = ({
  currentEvent,
  setGuestsList,
  token,
  closeModalHandler,
}) => {
  const [exampleTemplateLink, setExampleTemplateLink] = useState('');
  const [isLoading, setLoading] = useState(false);

  const { SERVER_URL } = getCustomURLs();
  const onButtonEnable = async (file) => {
    if (file.length !== 0) {
      const body = new FormData();
      body.append("file", file[0]);

      setLoading(true);

      try {
        const { data } = await axios.post('/GuestTickets/ParseFromCsv', body, {
          headers: getHeaders(token),
        });

        if (data.isSuccess) {
          setGuestsList(prev => {
            return [...prev, ...data.result];
          });
  
          closeModalHandler();
        } else {
          throw new Error(data.errorMessage);
        };
      } catch (error) {
        toast.error('File not uploaded')
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (currentEvent) {
      if (currentEvent.mapId) {
        setExampleTemplateLink("/FilesExamples/Guests_template.csv")
      } else {
        setExampleTemplateLink("/FilesExamples/Simple_Guests_template.csv")
      }
    }
  }, []);

  if (isLoading) {
    return (
      <div className='upload-file-actions__loader'>
        <NewLoader />
      </div>
    )
  }

  return (
    <div className="upload-file-actions">
      <div className="download">
          <form
              action={SERVER_URL + exampleTemplateLink}
              method="GET">
              <button>Download template</button>
          </form>
      </div>

      <div className="choose-file">
          <p>Choose the file ( .csv)</p>

          <Upload onButtonEnable={onButtonEnable} closePrevModal={closeModalHandler} />

      </div>
    </div>
  )
}
